export const mobileBreakpointNumber = 650;
export const mobileBreakPoint = `${mobileBreakpointNumber}px`;
